import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { formatNumber } from "./redux/utils";
import { fetchApi } from "./redux/api";

const IncomeExpenses = () => {
  const [revenue, setRevenue] = useState([]);
  const [revenueEx, setRevenueEx] = useState([]);
    const [expense, setExpense] = useState([]);
    const notes =['1a', '1b','2', '3', '4', '6', '7']
    const sur = (
      revenueEx.reduce((sum, item) => sum + (item.amount || 0), 0) +
      revenue.reduce(
        (sum, item) => sum + (item.amount || 0),
        0 - expense.reduce((sum, item) => sum + (item.amount || 0), 0)
      )
    )
    // alert(sur);
    useEffect(() => {
      fetchApi(`get_cash_report?query_type=FGN&code=1101`)
        .then((data) => {
          console.log(data);
          setRevenue(data.result);
        })
        .catch((err) => {
          console.log(err);
        });
      fetchApi(`get_cash_report?query_type=Expenditure&code=220`)
        .then((data) => {
          console.log(data);
          setExpense(data.result);
        })
        .catch((err) => {
          console.log(err);
        });
          fetchApi(`get_cash_report?query_type=FGN&code=120`)
            .then((data) => {
              console.log(data);
              setRevenueEx(data.result);
            })
            .catch((err) => {
              console.log(err);
            });
    }, []);
  const financialData = [
    {
      category: "Revenue",
      subCategories: [
        {
          description: "Revenue from Non-Exchange Transactions",
          subSubCategories: [
            {
              description: "FGN",
              items: [
                {
                  description: "Statutory Allocation (FAAC)",
                  notes: "1a",
                  2023: 48105746,
                  2022: 61832047,
                },
                {
                  description: "Value Added Tax (VAT) FAAC",
                  notes: "1bii",
                  2023: 64465340,
                  2022: 46154954,
                },
                {
                  description: "Other Receipts (SRAAC)",
                  notes: "2bi",
                  2023: 67945349,
                  2022: 5437140,
                },
              ],
            },
            {
              description: "States",
              items: [
                {
                  description: "Tax Revenue",
                  notes: "4",
                  2023: 67945349,
                  2022: 5437140,
                },
                {
                  description: "Other Revenue",
                  notes: "5",
                  2023: 180516435,
                  2022: 113424141,
                },
              ],
            },
          ],
        },
        {
          description: "Revenue from Exchange Transactions",
          items: [
            {
              description: "MDA's Revenue",
              notes: "6",
              2023: 22008517,
              2022: 16314351,
            },
            {
              description: "Investment Income",
              notes: "7",
              2023: 1143382,
              2022: 819992,
            },
          ],
        },
      ],
    },
    {
      category: "Expenses",
      items: [
        {
          description: "Wages, Salaries, and Employee Benefits",
          notes: "6",
          2023: 74083524,
          2022: 69091544,
        },
        {
          description: "Transport & Travelling - General",
          notes: "7",
          2023: 2385659,
          2022: 2328090,
        },
        {
          description: "Utilities - General",
          notes: "8",
          2023: 1052200,
          2022: 1045333,
        },
        {
          description: "Materials & Supplies General",
          notes: "9",
          2023: 7038531,
          2022: 8086530,
        },
        {
          description: "Training - General",
          notes: "10",
          2023: 2045198,
          2022: 2345493,
        },
        {
          description: "Total Operating Expense",
          notes: "",
          2023: 227795592,
          2022: 206406124,
        },
        {
          description: "Other Services",
          notes: "6",
          2023: 74083524,
          2022: 69091544,
        },
        {
          description: "Consulting and Professional Services",
          notes: "7",
          2023: 2385659,
          2022: 2328090,
        },
        {
          description: "Fuel & Lubricants - General ",
          notes: "8",
          2023: 1052200,
          2022: 1045333,
        },
        {
          description: "Financial Charges - General",
          notes: "9",
          2023: 7038531,
          2022: 8086530,
        },
        {
          description: "Miscellaneous Expenses - General",
          notes: "10",
          2023: 2045198,
          2022: 2345493,
        },
        {
          description: "Grants and Other Contributions",
          notes: "",
          2023: 227795592,
          2022: 206406124,
        },
        {
          description: "Cost of IGR and Collections",
          notes: "6",
          2023: 74083524,
          2022: 69091544,
        },
        {
          description: "Depreciation",
          notes: "7",
          2023: 2385659,
          2022: 2328090,
        },
        {
          description: "Public Debt Charges",
          notes: "8",
          2023: 1052200,
          2022: 1045333,
        },
        {
          description: "Other FAAC Deductions",
          notes: "9",
          2023: 7038531,
          2022: 8086530,
        },
        {
          description: "Loss on Exchange on Service Debts",
          notes: "10",
          2023: 2045198,
          2022: 2345493,
        },
        {
          description: "Total Operating Expenses",
          notes: "",
          2023: 227795592,
          2022: 206406124,
        },
        {
          description: "Surplus for the Year",
          notes: "",
          2023: 227795592,
          2022: 206406124,
        },
      ],
    },
  ];

  // Function to calculate totals for a list of items
  const calculateTotals = (items) => {
    const total2023 = items.reduce((sum, item) => sum + (item[2023] || 0), 0);
    const total2022 = items.reduce((sum, item) => sum + (item[2022] || 0), 0);
    return { total2023, total2022 };
  };
    const amount = {
      textAlign: "right",
      borderRight: "none",
    };


  return (
    <div className="container-fluid py-5">
      <style>
        {`
          .description {
            font-weight: bolder;
          }
          .subtotal-row {
            font-weight: bold;
            // background-color: #fff;
          }
          .total-row {
            // border-top: 3px solid #000;
            // border-bottom: 3px solid #000;
            font-weight: bold;
            // background-color: #ddd;
          }
            h1{
            color: #177e89;
            font-size: 22px;
            margin: 0;
            padding: 0;
            }
            header {
            background: linear-gradient(to right, #bc5449, white);
            padding: 40px 50px 2px 50px;
            border-bottom: 4px solid #2E8B57;
            margin-bottom: 15px;
            }
            footer {
            background: linear-gradient(to right, #420D09, #990f02);
            padding: 20px;
            }
        `}
      </style>
      <header>
        Report of the Accountant General with IPSAS Accrual Financial Statements
        for the Year Ended 31st December, 2023
      </header>
      <h1>Katsina State Government of Nigeria</h1>
      <h1>
        Consolidated Statement of Financial Performance (Income & Expenditure)
        for the Year Ended 31st December, 2023
      </h1>
      <Table striped hover bordered responsive>
        <thead>
          <tr>
            <th>Description</th>
            <th>Notes</th>
            <th>2023 (N'000)</th>
            <th>2022 (N'000)</th>
          </tr>
        </thead>
        <tbody>
          {/* {financialData.map((section, index) => { */}
          {/* const totals = calculateTotals(section.items); */}
          {/* return ( */}
          <React.Fragment>
            <>
              <tr>
                <td
                  colSpan="4"
                  className="bg-light font-weight-bold"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    textTransform: "uppercase",
                  }}
                >
                  {/* {section.description} */}Revenue
                </td>
              </tr>
              {revenue.map((item, subIndex) => (
                <tr key={subIndex}>
                  <td style={{ borderRight: "none" }}>{item?.description}</td>
                  {/* {JSON.stringify(notes)} */}
                  <td style={amount}>{notes[subIndex]}</td>
                  <td style={amount} className="text-right">
                    {item.amount?.toLocaleString()}
                  </td>
                  <td style={amount} className="text-right">
                    {item.amount?.toLocaleString()}
                  </td>
                </tr>
              ))}
              <tr>
                <td
                  className="font-weight-bold"
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    textTransform: "uppercase",
                  }}
                >
                  SubTotal
                </td>
                <td></td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {revenue
                    .reduce((sum, item) => sum + (item.amount || 0), 0)
                    .toLocaleString()}
                </td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {revenue
                    .reduce((sum, item) => sum + (item.amount || 0), 0)
                    .toLocaleString()}
                </td>
              </tr>
              {/* <tr>
                        <td className="font-weight-bold">Total</td>
                        <td></td>
                        <td
                          className="font-weight-bold text-right"
                          style={{
                            borderTop: "5px solid black",
                            borderBottom: "5px solid black",
                            fontWeight: "bold",
                            textAlign: "right",
                          }}
                        >
                          {revenue
                            .reduce((sum, item) => sum + (item.amount || 0), 0)
                            .toLocaleString()}
                        </td>
                        <td
                          className="font-weight-bold text-right"
                          style={{
                            borderTop: "5px solid black",
                            borderBottom: "5px solid black",
                            fontWeight: "bold",
                            textAlign: "right",
                          }}
                        >
                          {revenue
                            .reduce((sum, item) => sum + (item.amount || 0), 0)
                            .toLocaleString()}
                        </td>
                      </tr> */}
              <tr>
                <td
                  colSpan="4"
                  className="bg-light font-weight-bold"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    textTransform: "uppercase",
                  }}
                >
                  Revenue from Exchange Transactions
                </td>
              </tr>
              {revenueEx.map((item, subIndex) => (
                <tr key={subIndex}>
                  <td style={{ borderRight: "none" }}>{item?.description}</td>
                  <td style={amount}>{item?.notes}</td>
                  <td style={amount} className="text-right">
                    {item.amount?.toLocaleString()}
                  </td>
                  <td style={amount} className="text-right">
                    {item.amount?.toLocaleString()}
                  </td>
                </tr>
              ))}
              <tr>
                <td
                  className="font-weight-bold"
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    textTransform: "uppercase",
                  }}
                >
                  SubTotal
                </td>
                <td></td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {revenueEx
                    .reduce((sum, item) => sum + (item.amount || 0), 0)
                    .toLocaleString()}
                </td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {revenueEx
                    .reduce((sum, item) => sum + (item.amount || 0), 0)
                    .toLocaleString()}
                </td>
              </tr>
              <tr>
                <td
                  className="font-weight-bold"
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    textTransform: "uppercase",
                  }}
                >
                  Total
                </td>
                <td></td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {(
                    revenueEx.reduce(
                      (sum, item) => sum + (item.amount || 0),
                      0
                    ) +
                    revenue.reduce((sum, item) => sum + (item.amount || 0), 0)
                  ).toLocaleString()}
                  {/* {revenue
                    .reduce((sum, item) => sum + (item.amount || 0), 0)
                    .toLocaleString()} */}
                </td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {(
                    revenueEx.reduce(
                      (sum, item) => sum + (item.amount || 0),
                      0
                    ) +
                    revenue.reduce((sum, item) => sum + (item.amount || 0), 0)
                  ).toLocaleString()}
                </td>
              </tr>

              {/* ********************************** */}
              {/* Total Expense: Exchange Transactions */}
              <tr>
                <td
                  colSpan="4"
                  className="bg-light font-weight-bold"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    textTransform: "uppercase",
                  }}
                >
                  Expenses
                </td>
              </tr>
              {expense.map((item, subIndex) => (
                <tr key={subIndex}>
                  <td style={{ borderRight: "none" }}>{item?.description}</td>
                  <td style={amount}>{item?.notes}</td>
                  <td style={amount} className="text-right">
                    {item.amount?.toLocaleString()}
                  </td>
                  <td style={amount} className="text-right">
                    {item.amount?.toLocaleString()}
                  </td>
                </tr>
              ))}

              <tr>
                <td
                  className="font-weight-bold"
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    textTransform: "uppercase",
                  }}
                >
                  Total (Expenses)
                </td>
                <td></td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {expense
                    .reduce((sum, item) => sum + (item.amount || 0), 0)
                    .toLocaleString()}
                </td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {expense
                    .reduce((sum, item) => sum + (item.amount || 0), 0)
                    .toLocaleString()}
                </td>
              </tr>
              <tr>
                <td
                  className="font-weight-bold"
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    textTransform: "uppercase",
                  }}
                >
                  Surplus / ( Deficit)
                </td>
                <td></td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {Math.sign(sur) === -1
                    ? `(${Math.abs(sur).toLocaleString()})`
                    : sur.toLocaleString()}
                </td>
                <td
                  className="font-weight-bold text-right"
                  style={{
                    borderTop: "5px solid black",
                    borderBottom: "5px solid black",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {Math.sign(sur) === -1
                    ? `(${Math.abs(sur).toLocaleString()})`
                    : sur.toLocaleString()}
                </td>
              </tr>
            </>
          </React.Fragment>
          {/* ); */}
          {/* })} */}
        </tbody>
      </Table>
      <footer>
        <div
          style={{
            background: "white",
            padding: "5px",
            width: "30px",
            height: "30px",
            textAlign: "center",
          }}
        >
          1
        </div>
      </footer>
    </div>
  );
};

export default IncomeExpenses;
